// 자동 로그아웃 사유를 sessionStorage에 1회 기록 → 로그인 페이지가 1회 읽고 배너 렌더 후 제거.

export type LogoutReason = 'idle' | 'manual' | 'unauthorized';

interface StoredLogout {
  reason: LogoutReason;
  at: number;
}

const KEY = 'locker:logout-reason';

/** 로그아웃 직전 호출 — sessionStorage에 사유 기록. */
export function setLogoutReason(reason: LogoutReason): void {
  try {
    const payload: StoredLogout = { reason, at: Date.now() };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* quota 등의 예외 무시 — 배너 표시 실패일 뿐 */
  }
}

/** 1회 읽고 제거 — 로그인 페이지 마운트 시 호출. */
export function consumeLogoutReason(): StoredLogout | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    return JSON.parse(raw) as StoredLogout;
  } catch {
    return null;
  }
}
